import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import {useLocation } from "react-router-dom";
export default function App() {
    const location = useLocation();   
    return (
        <Layout>
            <Routes>
                {AppRoutes.map((route, index) => {
                    const { element, ...rest } = route;
                    return <Route key={index} {...rest} element={React.cloneElement(element, { location })} />;
                })}
            </Routes>
        </Layout>
    );
}

